import hexWithOpacity from "core-web/utils/hexWithOpacity";
import styled from "theme/libs/styled";
import Box from "theme/components/boxes/Box";

const LightGreenBox = styled(Box)`
    background-color: ${({ theme }) => `${hexWithOpacity(theme.colors.lightGreen, 50)}`};
    color: ${({ theme }) => `${theme.colors.darkGreen}`};
`;

LightGreenBox.propTypes = Box.propTypes;
LightGreenBox.defaultProps = Box.defaultProps;

export default LightGreenBox;
